import Vue from "vue";
import Router from "vue-router";
import vuxStore from "../store/index";
import Store from "store";
import { Message } from "element-ui";
import productionRouter from "@/components/production/route/index.js";
import purchaseRouter from "./purchase";
import questionRouter from "./question";
import finance from "./finance";
import info from "./info";
import logisticsRouter from "@/components/logistics/route/index.js";
import stockRouter from "@/components/stock/route/index.js";
import accountRouter from "@/components/account/route/index.js";
import settingRouter from "@/components/setting/route/index.js";
import home from "@/components/home/route/index.js";

Vue.use(Router);

function load(component) {
    return () => import(`@/components/${component}.vue`);
}

let router = new Router({
    // mode: "hash",
    routes: [
        {
            path: "/example",
            name: "example",
            component: load("example"),
            meta: {
                parent: "finance",
                child: "bill",
                deal: false
            }
        },
        {
            path: "/login",
            name: "login",
            component: load("login"),
            meta: {
                parent: "login",
                child: "login",
                deal: true
            }
        },
        purchaseRouter,
        questionRouter,
        finance,
        info,
        {
            path: "/dashboard",
            component: load("dashboard"),
            children: [
                home,
                productionRouter,
                logisticsRouter,
                stockRouter,
                accountRouter,
                settingRouter
            ]
        }
    ]
});

let routePath = {
    setting: "/dashboard/setting",
    account: "/dashboard/account",
    bill: "/finance",
    inout: "/finance/income",
    statistics: "/finance/summary",
    client: "/info/",
    agency: "/info/supplier",
    order: "/purchase/index",
    content: "/purchase/goods-content",
    inventory: "/dashboard/stock/store",
    input: "/dashboard/stock/pushstore",
    output: "/dashboard/stock/popstore",
    dispatching: "/dashboard/logistics",
    production: "/dashboard/production/workorder",
    cutting: "/dashboard/production/papercutting",
    scheduling: "/dashboard/production/scheduling",
    outsource: "/dashboard/production/outsource",
    quotation: "/question",
    home: "/dashboard/home"
};

router.beforeEach((to, from, next) => {
    console.log(to);
    //滚动条到顶部
    let elMain = document.querySelector(".el-main");
    if (elMain) {
        elMain.scrollTop = 0;
    }

    let token = Store.get("token");
    let user = Store.get("user");
    if (to.path === "/") {
        return next("/login");
    }

    if (to.path !== "/login") {
        if (!token || !user) {
            return next("/login");
            Store.set("token", "");
            Store.set("user", {});
        }
    } else {
        return next();
    }
    to.meta.permission = {};

    let par = to.meta.parent;
    let child = to.meta.child;
    let deal = to.meta.deal;
    let permission = user.permission;

    if (child instanceof Array) {
        child.forEach(item => {
            if (routePath[item]) {
                vuxStore.commit("activeIndexChange", routePath[item]);
            }
        });
    } else {
        if (routePath[child]) {
            vuxStore.commit("activeIndexChange", routePath[child]);
        }
    }
    if (par === "home" || par === "login") {
        return next();
    } else if (typeof child === "object") {
        let onoff = false;
        child.forEach(item => {
            to.meta.permission[item] = permission[par][item];
            if (permission[par][item] !== 1) {
                onoff = true;
            }
        });
        if (onoff) {
            return next();
        }
    }
    if (par === "system") {
        if (!permission[par][child]) {
            Message({
                message: "您没有该权限",
                type: "warning"
            });
            return next("/dashboard/home/");
        }
    }
    if (permission[par][child] === 1) {
        Message({
            message: "您没有该权限",
            type: "warning"
        });
        return next("/dashboard/home/");
    } else if (permission[par][child] === 2 && deal) {
        //只读权限 创建页面 没权限进入
        Message({
            message: "您没有该权限",
            type: "warning"
        });
        return next("/dashboard/home/");
    }
    to.meta.permission = permission[par][child];

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js